
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import EnhancedBetaSignupForm from "./EnhancedBetaSignupForm";

const HeroSection = () => {
  return (
    <section className="py-12 md:py-20 px-4 bg-gradient-to-br from-background to-muted/50">
      <div className="max-w-7xl mx-auto text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-6 leading-tight text-foreground md:text-7xl">
            AI-Native Recruitment Platform
          </h1>
          <p className="text-xl md:text-2xl text-muted-foreground mb-8 leading-relaxed">Transform your hiring process with InvenioCRM's multi-agent orchestration. Intelligent candidate sourcing, automated screening, and seamless team collaboration.</p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <EnhancedBetaSignupForm 
              trigger={
                <Button size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 py-4 text-lg">
                  Get Early Access
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              }
              source="hero_section"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
